import React from 'react';
import { Button } from "primereact/button";
import Cropper from "react-easy-crop";
import { useTranslation } from 'react-i18next';

const ImageCropper = ({
  selectedFile,
  crop,
  zoom,
  onCropChange,
  onZoomChange,
  onCropComplete,
  onConfirm,
  onCancel,
  title
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex flex-column align-items-center w-100">
      <span
        className="color-light text-center fw-medium w-80 mb-4"
        style={{ fontSize: "20px" }}
      >
        {title}
      </span>

      <div
        className="camera-frame-container"
        style={{
          width: "100%",
          maxWidth: "400px",
          height: "240px",
          position: "relative",
          backgroundColor: "#071126",
        }}
      >
        <Cropper
          image={selectedFile}
          crop={crop}
          zoom={zoom}
          aspect={1.6}
          onCropChange={onCropChange}
          onZoomChange={onZoomChange}
          onCropComplete={onCropComplete}
          style={{
            containerStyle: {
              width: "100%",
              height: "100%",
              backgroundColor: "#071126",
            },
          }}
        />
      </div>

      <div
        style={{
          position: "fixed",
          bottom: "20px",
          left: "0",
          right: "0",
          padding: "0 16px",
        }}
      >
        <Button
          label={`${t('common.confirm')}`}
          className="btn-primary w-100"
          onClick={onConfirm}
          size="large"
        />
        <Button
          label={`${t('common.cancel')}`}
          className="p-button-text color-danger w-100"
          onClick={onCancel}
          size="large"
          style={{
            fontWeight: "normal",
          }}
        />
      </div>
    </div>
  );
};

export default ImageCropper;